import { connect } from 'react-redux';
import {
    getTransHolderListForWealthManage,
    setLoadingPage,
    resetTransactionHolder,
    getAccountServiceOptions
} from '../../../shared/Actions/TransactionHistoryActions';
import {
    transactionCompositeDataAction
} from '../../../shared/Actions';
import ManageWealthTransaction from './ManageWealthTransaction';
import {
   memberDashboardActions,
   
} from '../../../shared/Actions';
import { addProfileContactInformations, clearContactDetails } from 'shared/Actions/ProfileSettingsAction';
/**
 * Map State to Props - Maps transactionHolderData from redux state
 * @param {Object} state
 */
export const mapStateToProps = state => ({
    transactionHolderData: state.transactionHolderData,
    memberDashboardData: state.memberDashboardData,
    profileInformationData:state.profileInformationData
});

/**
 * Map dispatch to props - For all actions from Transaction history actions
 */
export const mapDispatchToProps = {
    // getTransHolderList,
    // setLoadingPage,
    // resetTransactionHolder,
    ...memberDashboardActions,
    // updateAccountLevelAddresses
    getTransHolderListForWealthManage,
    setLoadingPage,
    resetTransactionHolder,
    getCompositeData: transactionCompositeDataAction.getTransactionCompositeData,
    getAccountServiceOptions,
    addProfileContactInformations,
    clearContactDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageWealthTransaction);
